module.exports = __webpack_public_path__ + "static/media/kim-img.b095bfbd.png";